import Form from 'flarum/common/components/Form';
import app from 'flarum/forum/app';
import Stream from 'flarum/common/utils/Stream';
import FormModal from 'flarum/common/components/FormModal';
import Button from 'flarum/common/components/Button';
export default class RequestModal extends FormModal {
  oninit(vnode) {
    super.oninit(vnode);
    this.username = Stream(this.attrs.nickname ? app.session.user.displayName() : app.session.user.username());
    this.userRequestAttr = "last".concat(this.attrs.nickname ? 'Nickname' : 'Username', "Request");
    this.lastRequest = app.session.user[this.userRequestAttr]();
    if (this.lastRequest) this.username(this.lastRequest.requestedUsername());
    this.success = false;
    this.password = Stream('');
    this.translationPrefix = "fof-username-request.forum.".concat(this.attrs.nickname ? 'nickname' : 'username', "_modals.request");
  }
  className() {
    return 'RequestUsernameModal Modal--small';
  }
  title() {
    return app.translator.trans("".concat(this.translationPrefix, ".title"));
  }
  content() {
    if (this.success) {
      return m("div", {
        className: "Modal-body"
      }, m(Form, {
        className: "Form--centered"
      }, m("p", {
        className: "helpText"
      }, app.translator.trans("".concat(this.translationPrefix, ".confirmation_message"))), m("div", {
        className: "Form-group"
      }, m(Button, {
        className: "Button Button--primary Button--block",
        onclick: this.hide.bind(this)
      }, app.translator.trans("".concat(this.translationPrefix, ".dismiss_button"))))));
    }
    return m("div", {
      className: "Modal-body"
    }, m(Form, {
      className: "Form--centered"
    }, this.lastRequest ? m("p", {
      className: "helpText"
    }, app.translator.trans("".concat(this.translationPrefix, ".current_request"), {
      name: this.lastRequest.requestedUsername()
    })) : '', m("div", {
      className: "Form-group"
    }, m("input", {
      type: "text",
      name: "text",
      className: "FormControl",
      placeholder: app.session.user.username(),
      bidi: this.username,
      disabled: this.deleteLoading || this.submitLoading
    })), app.forum.attribute('passwordlessSignUp') ? null : m("div", {
      className: "Form-group"
    }, m("input", {
      type: "password",
      name: "password",
      className: "FormControl",
      placeholder: app.translator.trans('core.forum.change_email.confirm_password_placeholder'),
      bidi: this.password,
      disabled: this.deleteLoading || this.submitLoading
    })), m("div", {
      className: "Form-group"
    }, Button.component({
      className: 'Button Button--primary Button--block',
      type: 'submit',
      loading: this.submitLoading
    }, app.translator.trans("".concat(this.translationPrefix, ".submit_button")))), this.lastRequest ? m("div", {
      className: "Form-group"
    }, Button.component({
      className: 'Button Button--primary Button--block',
      onclick: this.deleteRequest.bind(this),
      loading: this.deleteLoading
    }, app.translator.trans("".concat(this.translationPrefix, ".delete_button")))) : ''));
  }
  deleteRequest(e) {
    e.preventDefault();
    this.deleteLoading = true;
    this.lastRequest.delete();
    this.successAlert = app.alerts.show({
      type: 'success'
    }, app.translator.trans("".concat(this.translationPrefix, ".deleted")));
    app.session.user[this.userRequestAttr] = Stream();
    this.hide();
  }
  onsubmit(e) {
    e.preventDefault();
    this.alert = null;
    const currentAttr = this.attrs.nickname ? app.session.user.displayName() : app.session.user.username();
    if (this.username() === currentAttr) {
      this.hide();
      return;
    }
    this.submitLoading = true;
    app.store.createRecord('username-requests').save({
      requestedUsername: this.username(),
      forNickname: this.attrs.nickname
    }, {
      meta: {
        password: this.password()
      },
      errorHandler: this.onerror.bind(this)
    }).then(request => {
      app.session.user[this.userRequestAttr] = Stream(request);
      this.success = true;
      this.alertAttrs = null;
    }).catch(() => {}).then(this.loaded.bind(this));
  }
  onerror(error) {
    this.submitLoading = false;
    if (error.status === 401) {
      error.alert.content = app.translator.trans('core.forum.change_email.incorrect_password_message');
    }
    super.onerror(error);
  }
}
flarum.reg.add('fof-username-request', 'forum/components/RequestModal', RequestModal);